export default __webpack_public_path__ + "static/media/bottom-part.78023643.png";